import { unwrap } from "@nexxt/api-client";
import type { WorkQueueId } from "@nexxt/contracts/worklist";
import { queryOptions } from "@tanstack/react-query";
import { api, WORK_QUEUES_KEY } from "../../api";

// Server state of the home "Now" (pattern.md §10): the counts of the queues, in one call to worklist (ADR-136).

export const homeQueries = {
  all: WORK_QUEUES_KEY,

  /**
   * How many items wait in each queue asked, and since when the oldest; `failed`, the ones nobody answered for;
   * `unions`, the rows of each union of queues counted once (ADR-302).
   */
  counts: (queues: WorkQueueId[], unions: WorkQueueId[][] = []) =>
    queryOptions({
      queryKey: [...WORK_QUEUES_KEY, queues, unions],
      queryFn: ({ signal }) =>
        unwrap(
          api.worklist["queue-counts"].$get(
            {
              query: {
                queues: queues.join(","),
                ...(unions.length > 0 && { unions: unions.map((union) => union.join(".")).join(",") }),
              },
            },
            { init: { signal } },
          ),
        ),
    }),
};
